// Small pure helpers for mutating the nested `environments` array on a
// presupuesto version's form state, shared by BudgetDetailNew and
// BudgetFormNew.
//
// Field report #3 (chip task_5e3f9db9): the installation table is rendered
// from a FILTERED view of the environments
// (`.filter(env => env.installations.length > 0)`), so the map index there is
// the position in the filtered array, NOT the real index into the full
// `environments` array. Deleting an installation row by that filtered index
// mutated the wrong ambiente whenever an earlier ambiente had zero
// installations. The fix is to locate the target ambiente by object reference
// (`=== env`) instead of by a positional index - which is exactly what this
// helper does, so both screens share one correct implementation.

/** Remove the installation at `instIndex` from the ambiente that is `env`
 *  (matched by reference), returning a new environments array. If `env` is not
 *  found, the original array is returned unchanged. */
export function removeInstallationByEnvRef<
  E extends { installations?: unknown[] }
>(environments: E[], env: E, instIndex: number): E[] {
  const realIdx = environments.findIndex((e) => e === env);
  if (realIdx === -1) return environments;
  const next = [...environments];
  const current = next[realIdx].installations || [];
  next[realIdx] = {
    ...next[realIdx],
    installations: current.filter((_, idx) => idx !== instIndex),
  };
  return next;
}
